import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import TermsAndConditions from "./TermsAndConditions";

// Styled Components
const FooterWrapper = styled.footer`
  background: linear-gradient(90deg, #ee754c 0%, #ffb199 100%);
  padding: 40px 0;
  color: #fff;
  margin-top: 5px;
`;

const CompanyName = styled.h5`
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
`;

const Title = styled.h6`
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
`;

const FooterLink = styled.a`
  color: #fff;
  text-decoration: underline;
  font-size: 14px;

  &:hover {
    color: #e04b24;
  }
`;

const ContactText = styled.p`
  font-size: 14px;
  margin: 0 0 8px 0;

  svg {
    margin-right: 6px;
  }
`;

const SocialButton = styled.a`
  background-color: #fff;
  color: #ee754c;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition:
    transform 0.2s,
    box-shadow 0.2s,
    color 0.2s;

  &:hover {
    transform: scale(1.2);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    color: #e04b24;
  }

  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
  }
`;

const SocialWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const FooterCol = styled(Col)`
  margin-bottom: 24px;
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:last-child {
      border-right: none;
    }
  }
`;

function Footer() {
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);

  const handleTermsAndConditionsFalse = () => {
    setShowTermsAndConditions(false);
  };

  return (
    <>
      <FooterWrapper>
        <Container>
          <Row className="align-items-center">
            {/* Descrição */}
            <FooterCol xs={12} md={3}>
              <CompanyName>Soup</CompanyName>
              <p style={{ fontSize: "14px", margin: 0 }}>
                Gestão de reservas simplificada para o seu restaurante. Tornamos
                a experiência dos seus clientes melhor.
              </p>
            </FooterCol>

            {/* Contactos */}
            <FooterCol xs={12} md={3}>
              <Title>Contactos</Title>
              <ContactText>
                <FontAwesomeIcon icon={faEnvelope} />
                <FooterLink href="mailto:geral@soup.red">
                  geral@soup.red
                </FooterLink>
              </ContactText>
              <ContactText>
                <FontAwesomeIcon icon={faPhone} />
                <FooterLink href="tel:+351938745522">+351 938745522</FooterLink>
              </ContactText>
            </FooterCol>

            {/* Links úteis */}
            <FooterCol xs={12} md={2}>
              <Title>Links úteis</Title>
              <FooterLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowTermsAndConditions(true);
                }}
              >
                Termos e Condições
              </FooterLink>
            </FooterCol>

            {/* Redes sociais */}
            <FooterCol xs={12} md={3}>
              <Title>Siga-nos</Title>
              <SocialWrapper>
                {[
                  //{ icon: faFacebookF, url: "#" },
                  {
                    icon: faInstagram,
                    url: "https://www.instagram.com/soupreserv/",
                  },
                  //{ icon: faLinkedinIn, url: "#" },
                  // { icon: faXTwitter, url: "#" },
                ].map((item, index) => (
                  <SocialButton
                    key={index}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={item.icon} size="sm" />
                  </SocialButton>
                ))}
              </SocialWrapper>
            </FooterCol>
          </Row>

          <Row>
            <Col
              className="text-center mt-3"
              style={{ fontSize: "13px", color: "rgba(255,255,255,0.7)" }}
            >
              Copyright &copy; {new Date().getFullYear()} Soup. Todos os
              direitos reservados.
            </Col>
          </Row>
        </Container>

        <TermsAndConditions
          showTermsAndConditions={showTermsAndConditions}
          setSetShowTermsAndConditions={handleTermsAndConditionsFalse}
        />
      </FooterWrapper>
    </>
  );
}

export default Footer;
